export default __webpack_public_path__ + "static/media/checked_radio.0044a5d1.svg";